/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app-nav.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../src/app/components/app-nav/app-nav.component';
const styles_AppNavComponent:any[] = [i0.styles];
export const RenderType_AppNavComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AppNavComponent,data:{}});
export function View_AppNavComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(2,[(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),25,'div',[['class','app-nav']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),22,'div',[['class','wrapper']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
      ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'a',[['routerLink',
      'schedule'],['routerLinkActive','active']],[[1,'target',0],[8,'href',4]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,6).onClick($event.button,$event.ctrlKey,$event.metaKey,
          $event.shiftKey)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(671744,[[2,4]],0,i2.RouterLinkWithHref,[i2.Router,
      i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},(null as any)),
      i1.ɵdid(1720320,(null as any),2,i2.RouterLinkActive,[i2.Router,i1.ElementRef,
          i1.Renderer2,i1.ChangeDetectorRef],{routerLinkActive:[0,'routerLinkActive']},
          (null as any)),i1.ɵqud(603979776,1,{links:1}),i1.ɵqud(603979776,2,{linksWithHrefs:1}),
      (_l()(),i1.ɵted((null as any),['Schedule'])),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),5,'a',[['routerLink','meals'],
          ['routerLinkActive','active']],[[1,'target',0],[8,'href',4]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,13).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(671744,[[4,4]],0,i2.RouterLinkWithHref,
          [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵdid(1720320,(null as any),2,i2.RouterLinkActive,[i2.Router,
          i1.ElementRef,i1.Renderer2,i1.ChangeDetectorRef],{routerLinkActive:[0,'routerLinkActive']},
          (null as any)),i1.ɵqud(603979776,3,{links:1}),i1.ɵqud(603979776,4,{linksWithHrefs:1}),
      (_l()(),i1.ɵted((null as any),['Meals'])),(_l()(),i1.ɵted((null as any),['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),5,'a',[['routerLink','workouts'],
          ['routerLinkActive','active']],[[1,'target',0],[8,'href',4]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,20).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(671744,[[6,4]],0,i2.RouterLinkWithHref,
          [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵdid(1720320,(null as any),2,i2.RouterLinkActive,[i2.Router,
          i1.ElementRef,i1.Renderer2,i1.ChangeDetectorRef],{routerLinkActive:[0,'routerLinkActive']},
          (null as any)),i1.ɵqud(603979776,5,{links:1}),i1.ɵqud(603979776,6,{linksWithHrefs:1}),
      (_l()(),i1.ɵted((null as any),['Workouts'])),(_l()(),i1.ɵted((null as any),['\n      '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),['\n  ']))],
      (_ck,_v) => {
        const currVal_2:any = 'schedule';
        _ck(_v,6,0,currVal_2);
        const currVal_3:any = 'active';
        _ck(_v,7,0,currVal_3);
        const currVal_6:any = 'meals';
        _ck(_v,13,0,currVal_6);
        const currVal_7:any = 'active';
        _ck(_v,14,0,currVal_7);
        const currVal_10:any = 'workouts';
        _ck(_v,20,0,currVal_10);
        const currVal_11:any = 'active';
        _ck(_v,21,0,currVal_11);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,6).target;
        const currVal_1:any = i1.ɵnov(_v,6).href;
        _ck(_v,5,0,currVal_0,currVal_1);
        const currVal_4:any = i1.ɵnov(_v,13).target;
        const currVal_5:any = i1.ɵnov(_v,13).href;
        _ck(_v,12,0,currVal_4,currVal_5);
        const currVal_8:any = i1.ɵnov(_v,20).target;
        const currVal_9:any = i1.ɵnov(_v,20).href;
        _ck(_v,19,0,currVal_8,currVal_9);
      });
}
export function View_AppNavComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-nav',([] as any[]),
      (null as any),(null as any),(null as any),View_AppNavComponent_0,RenderType_AppNavComponent)),
      i1.ɵdid(49152,(null as any),0,i4.AppNavComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const AppNavComponentNgFactory:i1.ComponentFactory<i4.AppNavComponent> = i1.ɵccf('app-nav',
    i4.AppNavComponent,View_AppNavComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./ngfactory/src/app/components/app-nav/app-nav.component.ngfactory.ts